import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

export const populateStrategy = '';

/**
 * Populates a FormGroup with the given data. Supports FormControl, FormGroup and FormArray.
 */
export const populateForm = (form: UntypedFormGroup, model: { [key: string]: any }, readonly = false): void => {
    const formArray = {};

    Object.keys(model).forEach((k) => {
        const control = form.get(k);

        if (control === null) {
            return;
        }

        if (control instanceof UntypedFormArray) {
            formArray[k] = form.get(k) as UntypedFormArray;

            // Clear previous results
            while (formArray[k].length !== 0) {
                formArray[k].removeAt(0);
            }

            model[k].forEach((obj) => {
                // Create new FormGroup
                const controls: { [key: string]: AbstractControl } = {};

                // Setup controls for the FormGroup (also possible with FormBuilder.group, but we don't want the dependency)
                Object.keys(obj).forEach((controlName) => {
                    controls[controlName] = new UntypedFormControl();
                    controls[controlName].patchValue(obj[controlName]);
                });

                const group = new UntypedFormGroup(controls);

                if (readonly) {
                    group.disable();
                } else {
                    group.enable();
                }

                // Push values to FormArray
                formArray[k].push(group);
            });
        } else if (control instanceof UntypedFormGroup) {
            const keys = Object.keys(model[k]);

            keys.forEach((key) => {
                const inputField = control.get(key);

                if (inputField !== null) {
                    // Uses 'onlySelf' to prevent trashing propagation
                    control.get(key)!.patchValue(model[k][key], { onlySelf: true });
                }
            });

            // Update parent because we used the option 'onlySelf'
            control.updateValueAndValidity();
        } else {
            // Does conversion of value for property keys that contain 'Date'
            const value = k.includes('Date') ? (model[k] !== null ? new Date(model[k]) : null) : model[k];

            // Set value
            control.patchValue(value);
        }
    });
};
